import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Form, Modal } from "react-bootstrap";
import Cropper from "react-easy-crop";

export const ImageCropper = ({
  isLoading,
  show,
  src,
  imageFile,
  imageType,
  aspectRatio,
  toggle,
  handleCrop,
}) => {
  const { t } = useTranslation();

  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  // const [image, setImage] = useState(null);
  const [cropData, setCropData] = useState(null);

  const onCropComplete = (_, croppedAreaPixels) => {
    setCropData(croppedAreaPixels);
  };

  const handleZoomChange = (e) => {
    setZoom(parseFloat(e.target.value));
  };

  const handleZoomOnClick = (type) => {
    if (type === "zoomIn" && zoom < 3) {
      setZoom((prev) => prev + 0.5);
    }
    if (type === "zoomOut" && zoom > 1) {
      setZoom((prev) => prev - 0.5);
    }
  };

  // Submit & Reset
  const getCroppedImg = (imageSrc, pixelCrop) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.src = imageSrc;

      image.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = pixelCrop.width;
        canvas.height = pixelCrop.height;

        ctx.drawImage(
          image,
          pixelCrop.x,
          pixelCrop.y,
          pixelCrop.width,
          pixelCrop.height,
          0,
          0,
          pixelCrop.width,
          pixelCrop.height
        );

        // Convert canvas to blob
        canvas.toBlob((blob) => {
          if (!blob) {
            reject(new Error("Canvas is empty"));
            return;
          }
          const croppedFile = new File([blob], imageFile.name, {
            type: "image/jpeg",
            lastModified: Date.now(),
          });
          // const croppedImageUrl = URL.createObjectURL(croppedFile);
          resolve(croppedFile);
        }, "image/jpeg");
      };

      image.onerror = (error) => {
        reject(error);
      };
    });
  };

  const onSave = async (e) => {
    const croppedImageFile = await getCroppedImg(src, cropData);
    await handleCrop(e, croppedImageFile);
    toggle();
  };

  return (
    <Modal
      show={show}
      onHide={toggle}
      centered
      backdrop="static"
      keyboard={false}
      size="lg"
      className={`image-cropper-modal ${
        imageType === "profile" ? "profile-picture" : ""
      }`}
    >
      <Modal.Header closeButton>
        <Modal.Title>Edit Photo</Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        <Cropper
          image={src}
          crop={crop}
          zoom={zoom}
          aspect={aspectRatio ? aspectRatio : 1 / 1}
          objectFit="horizontal-cover"
          // onMediaLoaded={setImage}
          onCropChange={setCrop}
          onCropComplete={onCropComplete}
          onZoomChange={setZoom}
        />
      </Modal.Body>
      <Modal.Footer className="border-0 justify-content-center">
        <div className="zoom-range d-flex align-items-center w-100">
          <button
            onClick={() => handleZoomOnClick("zoomOut")}
            className="text-slate-400 mx-2 w-8 h-8 d-flex justify-content-center items-align-center text-2xl border-0 bg-transparent"
          >
            -
          </button>
          <Form.Range
            value={zoom}
            onChange={handleZoomChange}
            min={1}
            max={3}
            step={0.1}
          />
          <button
            onClick={() => handleZoomOnClick("zoomIn")}
            className="text-slate-400 mx-2 w-8 h-8 d-flex justify-content-center items-align-center text-2xl border-0 bg-transparent"
          >
            +
          </button>
        </div>
        <Button variant="outline-primary" onClick={toggle} className="">
          {t("common.button.cancel")}
        </Button>
        <Button variant="primary" onClick={onSave} disabled={isLoading}>
          {t("common.button.save")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
